import styled from "@emotion/styled";
import { Flex } from "@otrium/core";

const StyledCarouselHeader = styled(Flex)`
  align-items: center;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    margin-inline: ${({ theme }) => theme.space.space16};
  }
`;

const StyledTitleWrapper = styled.div`
  svg {
    @media (min-width: ${({ theme }) => theme.breakpoints[1]}) {
      display: none;
    }
  }
`;

export { StyledCarouselHeader, StyledTitleWrapper };
